// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Fri Sep 22 2023
 **/

import React, { forwardRef, Ref } from "react";
import { IconProps } from "../Icon";
import Svg from "@/frameworks/designStuff/components/Contents/Icon/Svg";
const VideoRecordExtension = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy: string | undefined = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 36 36"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<rect width={36} height={36} rx={8} fill="#7E9A0D" />
				<path
					opacity={0.8}
					fillRule="evenodd"
					clipRule="evenodd"
					d="M22 11.6154C22 9.06638 20.2091 7 18 7C15.7909 7 14 9.06638 14 11.6154V16.3846C14 18.9336 15.7909 21 18 21C20.2091 21 22 18.9336 22 16.3846V11.6154ZM26 16.6667C26 16.1757 25.602 15.7778 25.1111 15.7778C24.6202 15.7778 24.2222 16.1757 24.2222 16.6667C24.2222 20.1031 21.4364 22.8889 18 22.8889C14.5636 22.8889 11.7778 20.1031 11.7778 16.6667C11.7778 16.1757 11.3798 15.7778 10.8889 15.7778C10.398 15.7778 10 16.1757 10 16.6667C10 20.7846 13.1113 24.1759 17.1115 24.6179L17.1111 29.1111C17.1111 29.602 17.5091 30 18 30C18.4909 30 18.8889 29.602 18.8889 29.1111L18.8897 24.6177C22.8893 24.1752 26 20.7842 26 16.6667Z"
					fill="white"
				/>
			</Svg>
		);
	}
);
VideoRecordExtension.defaultProps = {
	size: 36,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default VideoRecordExtension;
